<template>

    <div class="areas" role="tablist">

        <div class="area" v-for="(area, areaIndex) in areas" :key="areaIndex">
            <div class="toggle no-selection" role="tab" v-b-toggle="`areas-list-${areaIndex}`">
                <div class="icon-box">
                    <div class="icon" :style="area.has_icon ? {'background-image': 'url(' + area.icon_url + ')'} : {}"></div>
                </div>
                <div class="text">
                    <p class="description text-truncate" :title="area.display_description">{{ area.display_description }}</p>
                    <p class="packages-count">{{ t.__('Liczba pakietów') }}: {{ area.packages.length }}</p>
                </div>
                <div class="enter-btn"></div>
            </div>

            <b-collapse :id="'areas-list-' + areaIndex" accordion="areas-list-accordion" role="tabpanel">
                <div class="packages-list">
                    <div class="row" v-if="area.packages.length">
                        <div class="col-md-3" v-for="(package_, packageIndex) in area.packages" :key="packageIndex">
                            <div class="package-item">
                                <div class="img" :style="package_.has_icon ? {'background-image': 'url(' + package_.icon_url + ')'} : {}"></div>
                                <div class="bottom-bar">
                                    <div class="name text-truncate" :title="package_.display_name">{{ package_.display_name }}</div>
                                    <a :href="package_.resources_url" class="icon" v-if="package_.has_resources"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="area.packages.length === 0">{{ t.__('Brak przypisanych pakietów z tego obszaru') }}</p>
                </div>
                <div class="packages-list available-packages" v-if="area.available_packages.length">
                    <div class="heading">{{ t.__('Dostępne pakiety') }}</div>
                    <div class="row">
                        <div class="col-md-3" v-for="(package_, packageIndex) in area.available_packages" :key="packageIndex">
                            <div class="package-item">
                                <div class="img" :style="package_.has_icon ? {'background-image': 'url(' + package_.icon_url + ')'} : {}"></div>
                                <div class="bottom-bar">
                                    <div class="name text-truncate" :title="package_.display_name">{{ package_.display_name }}</div>
                                    <a :href="package_.resources_url" class="icon" v-if="package_.has_resources"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>

    </div>

</template>

<script>
export default {
    name: "Resources",

    props: {
        areas: Array
    }
}
</script>

<style scoped>

</style>
